/** VERSION: 1.1.0 Grid-only integration: toolbar (pagination, sorting, grid display, limit, breadcrumb) merged; list view removed **/


(function() {
    // Basic globals
    var onSale = false,
        soldOut = false,
        priceVaries = false,
        images = [],
        boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];


    function debounce(fn, wait) {
        var t;
        return function() {
            var ctx = this,
                args = arguments;
            clearTimeout(t);
            t = setTimeout(function() {
                fn.apply(ctx, args);
            }, wait);
        };
    }


    // Inject Boost app lib context
    BoostPFS.inject(this); // Rely on Boost App Lib V2 runtime [web:22][web:11]


    // ---------------- Toolbar (grid-only) ----------------


    // Pagination (unchanged logic)
    ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        $(".boost-pfs-filter-toolbar-item").children(".boost-pfs-filter-total-product").html(totalProduct + " Products");
        $(".boost-pfs-filter-toolbar-item").children(".boost-pfs-filter-total-product").children("span").removeClass(".boost-pfs-filter-total-product");
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        if (totalPage <= 1) return '';


        var paginationHtml = boostPFSTemplate.paginateHtml;


        var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);


        var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);


        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) beforeCurrentPageArr.unshift('...');
        if (currentPage - 4 >= 0) beforeCurrentPageArr.unshift(1);
        beforeCurrentPageArr.push(currentPage);


        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) afterCurrentPageArr.push('...');
        if (currentPage + 3 <= totalPage) afterCurrentPageArr.push(totalPage);


        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
        return paginationHtml;
    }; // [web:12][web:17]


    // Sorting
    ProductSorting.prototype.compileTemplate = function() {
        var html = boostPFSTemplate.sortingHtml;
        if (boostPFSThemeConfig.custom.show_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    var activeClass = (paramSort == k) ? 'boost-pfs-filter-sort-item-active' : '';
                    sortingItemsHtml += '<li aria-label="' + sortingArr[k] + '"><a href="#" data-sort="' + k + '" class="' + activeClass + '" title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' + sortingArr[k] + '</a></li>';
                }
                html = html.replace(/{{sortingItems}}/g, sortingItemsHtml);
                html = html.replace(/{{sortingLabel}}/g, Labels.sorting);
            }
        }
        return html;
    }; // [web:11]


    ProductSorting.prototype.render = function() {
        jQ(Selector.topSorting).html(this.compileTemplate());
        if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
            jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
        }
        var labelSort = '';
        var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
        var sortingList = Utils.getSortingList();
        labelSort = (paramSort.length > 0 && sortingList && sortingList[paramSort]) ? sortingList[paramSort] : Labels.sorting_heading;
        jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
    }; // [web:11]


    ProductSorting.prototype.bindEvents = function() {
        jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
            e.preventDefault();
            FilterApi.setParam('sort', jQ(this).data('sort'));
            FilterApi.setParam('page', 1);
            FilterApi.applyFilter('sort');
        });
        jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
            jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
        });
        jQ(Selector.filterTreeMobileButton).click(function() {
            jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
        });
        jQ(document).on('click', function(e) {
            if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
                jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
            }
        });
    }; // [web:11]


    // Grid-only Display Type (no list view)
    function buildDisplayTitle(type, count) {
        if (type === 'grid') {
            if (typeof count === 'undefined' || count === 0) return Labels.gridView || 'Grid view';
            return (Labels.gridViewColumns || 'Grid view {{ count }} Columns').replace(/{{ count }}/g, count);
        }
        return '';
    }


    ProductDisplayType.prototype.compileTemplate = function() {
        // Only grid controls. If multi-column is enabled and not mobile, render 2-6.
        var itemHtml = '<span>' + (boostPFSThemeConfig.label.toolbar_viewas || 'View') + '</span>';
        var multi = (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile());
        if (multi) {
            itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'grid') + '" title="' + buildDisplayTitle('grid', 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
            itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'grid') + '" title="' + buildDisplayTitle('grid', 3) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
            itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'grid') + '" title="' + buildDisplayTitle('grid', 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
            itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'grid') + '" title="' + buildDisplayTitle('grid', 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
            itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'grid') + '" title="' + buildDisplayTitle('grid', 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
        } else {
            itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'grid') + '" title="' + buildDisplayTitle('grid') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
        }
        itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);
        return itemHtml;
    }; // [web:22][web:3]


    var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
    ProductDisplayType.prototype.render = function() {
        originalRenderProductDisplayType.call(this);
        if (this.$element.length) {
            this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
            // If multi-col config exists, set active column and adjust product widths
            if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
                var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
                this.$element.find(this.selector.productDisplayTypeGrid).each(function() {
                    var $parent = jQ(this).parent();
                    var $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
                    var $activeClass = $cssNames[$cssNames.length - 1];
                    var indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];


                    if ($parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view') == $activeClass) {
                        jQ(this).addClass('active');
                        if (jQ('.boost-pfs-filter-product-item').length > 0) {
                            var arrClass = jQ('.boost-pfs-filter-product-item').attr('class').split(' ');
                            var prevClass = '';
                            for (var i = 0; i < arrClass.length; i++) {
                                if (arrClass[i].match(/(^|\s)boost-pfs-filter-grid-width-\S+/g)) {
                                    prevClass = arrClass[i];
                                    break;
                                }
                            }
                            jQ('.boost-pfs-filter-product-item').removeClass(prevClass);
                            jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
                        }
                    } else if (!$parent.hasClass('boost-pfs-filter-view-as-click') && (jQ(this).data('view') + '').split('-')[1] == curentGridColumn) {
                        jQ(this).addClass('active');
                    }
                });
            } else {
                this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
            }
        }
    }; // [web:22]


    // Per-page Limit (fixed to loop over arr)
    ProductLimit.prototype.compileTemplate = function() {
        var html = '';
        if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
            var numberList = Settings.getSettingValue('general.showLimitList');
            if (numberList != '') {
                var showLimitItemsHtml = '';
                var arr = numberList.split(',');
                for (var k = 0; k < arr.length; k++) {
                    showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
                }
                html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
            }
        }
        return html;
    }; // [web:11]


    // Breadcrumb
    Breadcrumb.prototype.compileTemplate = function(colData) {
        if (!colData) colData = this.collectionData;
        var breadcrumbItemsHtml = '';
        if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
            if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
                var colInfo = colData.collection;
                if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
                    breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
                    breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
                    breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
                } else {
                    breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
                }
            } else {
                breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
            }
        }
        return breadcrumbItemsHtml;
    }; // [web:22]


    // ---------------- Helpers and product item rendering ----------------


    function getBoostFilterConfig() {
        if (typeof window !== 'undefined' && typeof window.boostPFSFilterConfig === 'object' && window.boostPFSFilterConfig) {
            return window.boostPFSFilterConfig;
        }
        if (typeof window !== 'undefined' && typeof window.boostPFSThemeConfig === 'object' && window.boostPFSThemeConfig && window.boostPFSThemeConfig.custom) {
            return {
                general: {
                    aspect_ratio: window.boostPFSThemeConfig.custom.aspect_ratio || 'false',
                    cropImagePossitionEqualHeight: window.boostPFSThemeConfig.custom.product_img_crop || 'center'
                }
            };
        }
        return {
            general: {
                aspect_ratio: 'false',
                cropImagePossitionEqualHeight: 'center'
            }
        };
    } // [web:22]


    var isMobileUA = (function() {
        var ua = navigator.userAgent || '';
        return /android|iphone|ipod|ipad|iemobile|opera mini|mobile/i.test(ua);
    })();


    function escapeHtml(str) {
        if (!str && str !== 0) return '';
        return (str + '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
            .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function getSelectedColorFromChips() {
        var $chip = jQ(".boost-pfs-filter-option-item-list .selected > span[title]").first();
        if (!$chip.length) return ''; // nothing selected
        return $chip.attr("title"); // return the first selected title only
    }

    // [web:3]


    function prepareShopifyData(data) {
        soldOut = !data.available;
        onSale = data.compare_at_price_min > data.price_min;
        priceVaries = data.price_min != data.price_max;
        images = data.images_info || [];
        return data;
    } // [web:22]


    function buildGridWidthClass() {
        var gridWidthClass = '';
        switch (boostPFSThemeConfig.custom.products_per_row) {
            case 2:
                gridWidthClass = 'boost-pfs-filter-grid-width-2';
                break;
            case 3:
                gridWidthClass = 'boost-pfs-filter-grid-width-3';
                break;
            case 5:
                gridWidthClass = 'boost-pfs-filter-grid-width-5';
                break;
            case 6:
                gridWidthClass = 'boost-pfs-filter-grid-width-6';
                break;
            default:
                gridWidthClass = 'boost-pfs-filter-grid-width-4';
                break;
        }
        switch (boostPFSThemeConfig.custom.products_per_row_m) {
            case 1:
                gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
                break;
            case 3:
                gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
                break;
            default:
                gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
                break;
        }
        return gridWidthClass;
    } // [web:22]


    function findVariantImageByColor(data, colorName) {
        if (!Array.isArray(data.variants) || !colorName) return '';
        var cn = (colorName + '').trim().toLowerCase();
        var match = data.variants.find(function(v) {
            return v && (v.option2 + '').trim().toLowerCase() === cn && (v.image || (v.featured_image && v.featured_image.src));
        });
        if (match) return match.image || (match.featured_image && match.featured_image.src) || '';
        match = data.variants.find(function(v) {
            var val = (v && v.option2) ? (v.option2 + '').toLowerCase() : '';
            return val && cn && val.indexOf(cn) !== -1 && (v.image || (v.featured_image && v.featured_image.src));
        });
        return match ? (match.image || (match.featured_image && match.featured_image.src) || '') : '';
    } // [web:3]

    function collectCoreSeasonalBuckets(handle) {
        var buckets = {
            c1: [],
            c2: [],
            c3: [],
            c4: [],
            s1: [],
            s2: [],
            s3: [],
            s4: []
        };

        function pushTo(bucketArr, color, img) {
            var cname = (color || '').trim();
            if (!cname) return;
            bucketArr.push({
                color: cname,
                image: img || ''
            });
        }

        try {
            var $c1 = jQ('#product-core1-' + handle + '-c1');
            if ($c1 && $c1.length) {
                $c1.children('option').each(function() {
                    pushTo(buckets.c1, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}
        try {
            var $c2 = jQ('#product-core2-' + handle + '-c2');
            if ($c2 && $c2.length) {
                $c2.children('option').each(function() {
                    pushTo(buckets.c2, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}
        try {
            var $c3 = jQ('#product-core3-' + handle + '-c3');
            if ($c3 && $c3.length) {
                $c3.children('option').each(function() {
                    pushTo(buckets.c3, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}
        try {
            var $c4 = jQ('#product-core4-' + handle + '-c4');
            if ($c4 && $c4.length) {
                $c4.children('option').each(function() {
                    pushTo(buckets.c4, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}

        try {
            var $s1 = jQ('#product-seasonal1-' + handle + '-s1');
            if ($s1 && $s1.length) {
                $s1.children('option').each(function() {
                    pushTo(buckets.s1, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}
        try {
            var $s2 = jQ('#product-seasonal2-' + handle + '-s2');
            if ($s2 && $s2.length) {
                $s2.children('option').each(function() {
                    pushTo(buckets.s2, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}
        try {
            var $s3 = jQ('#product-seasonal3-' + handle + '-s3');
            if ($s3 && $s3.length) {
                $s3.children('option').each(function() {
                    pushTo(buckets.s3, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}
        try {
            var $s4 = jQ('#product-seasonal4-' + handle + '-s4');
            if ($s4 && $s4.length) {
                $s4.children('option').each(function() {
                    pushTo(buckets.s4, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
            }
        } catch (e) {}

        return buckets;
    }


    function buildProductOptionSwatches(data) {
        var swatchesProductOptionHtml = '';
        if (!data || !Array.isArray(data.variants)) return swatchesProductOptionHtml;

        var handle = (data.handle || '').toLowerCase();

        // Collect main product swatches directly here
        var entries = [];
        var seen = new Set();
        data.variants.forEach(function(v) {
            var cname = v && v.option2 ? v.option2.trim() : '';
            if (!cname) return;
            var key = cname.toLowerCase();
            if (seen.has(key)) return;
            seen.add(key);

            var img = v.image || (v.featured_image && v.featured_image.src) || '';
            entries.push({
                color: cname,
                image: img || ''
            });
        });
        if (entries.length === 0) return swatchesProductOptionHtml;

        //  Core/seasonal for counts only
        var buckets = collectCoreSeasonalBuckets(handle);

        // collect fits (size/fit info)
        var fits = [];
        data.variants.forEach(function(v) {
            if (v && v.option3 && fits.indexOf(v.option3) === -1) fits.push(v.option3);
        });
        if (fits.length) {
            swatchesProductOptionHtml += '<span class="fitElem customSize">Available in ' + escapeHtml(fits.join(', ')) + '</span>';
        }

        // total count = main entries + all core + all seasonal
        var totalCount = entries.length;
        Object.keys(buckets).forEach(function(k) {
            totalCount += buckets[k].length;
        });

        // Render swatches (max 4 from "entries")
        var maxSwatches = 4;
        swatchesProductOptionHtml += '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-option boost-pfs-filter-item-swatch" data-handle="' + data.handle + '">';

        entries.slice(0, maxSwatches).forEach(function(entry) {
            var swatchName = entry.color || '';
            var dataImg = escapeHtml(entry.image || '');
            var aria = escapeHtml(swatchName);

            swatchesProductOptionHtml += isMobileUA ?
                '<li onclick="window.eventColorSwatchesChange(this)">' :
                '<li onmouseover="window.eventColorSwatchesChange(this)">';

            if (boostPFSThemeConfig && boostPFSThemeConfig.custom && boostPFSThemeConfig.custom.show_swatch_tooltip) {
                swatchesProductOptionHtml += '<div class="boost-pfs-product-item-tooltip">' + aria + '</div>';
            }

            swatchesProductOptionHtml += '<span tabindex="0" data-img="' + dataImg + '" data-colorname="' + aria + '" data-value="' + aria + '" aria-label="' + aria + '"></span>';
            swatchesProductOptionHtml += '</li>';
        });

        // "+ More Colors" if totalCount > maxSwatches
        if (totalCount > maxSwatches) {
            swatchesProductOptionHtml += '<li class="boost-pfs-filter-item-swatch-plus">' +
                '<a tabindex="0" aria-label="More colors" href="' +
                ((typeof Utils !== 'undefined' && Utils.buildProductItemUrlWithVariant) ? Utils.buildProductItemUrlWithVariant(data) : '#') +
                '">+ More Colors</a></li>';
        }

        swatchesProductOptionHtml += '</ul>';
        return swatchesProductOptionHtml;
    }




    function buildImages(data) {
        var html = '',
            rangeWidths = boostPFSRangeWidths.slice(0),
            paddingTop = 100,
            dataSrcSet = '',
            dataWidths = '',
            dataSizes = 'auto',
            imgAlt = escapeHtml(data.title || ''),
            flipImageSrcSet = '';


        var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
            boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
            boostPFSThemeConfig.custom.active_image_swap === true;


        for (var i = 0; i < rangeWidths.length; i++) {
            var w = rangeWidths[i];
            var mainSrc = Utils.getFeaturedImage(images, w + 'x') || '';
            dataSrcSet += mainSrc + ' ' + w + 'w';
            dataWidths += w;
            if (activeSwapImage && images[1] && images[1].src) {
                flipImageSrcSet += Utils.optimizeImage(images[1]['src'], w + 'x') + ' ' + w + 'w';
            }
            if (i < rangeWidths.length - 1) {
                dataSrcSet += ', ';
                dataWidths += ', ';
                if (activeSwapImage) flipImageSrcSet += ', ';
            }
        }


        if (images && images && images.width && images.height) {
            var aspectRatio = images.width / images.height;
            paddingTop = 1 / aspectRatio * 100;
        }


        html += '<div class="quick-view-button"><a class="quick-view" data-handle="' + escapeHtml(data.handle || '') + '" href="javascript:void(0);">Quick View</a></div>';
        html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" style="padding-top:' + paddingTop + '%;">';
        html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad" ' +
            'data-srcset="' + dataSrcSet + '" ' +
            'data-src="' + (Utils.getFeaturedImage(images, rangeWidths + 'x') || '') + '" ' +
            'data-widths="[' + dataWidths + ']" ' +
            'data-sizes="' + dataSizes + '" ' +
            'src="' + boostPFSImgDefaultSrc + '" ' +
            'alt="' + imgAlt + '" ';


        if (activeSwapImage && images[1] && images[1].src) {
            html += ' data-img-flip-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths + 'x') + '" ' +
                ' data-img-flip-srcset="' + flipImageSrcSet + '" ';
        }
        html += '/></a>';


        return html;
    } // [web:22]


    function buildVendor(data) {
        var html = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
            boostPFSThemeConfig.custom.show_vendor === true) {
            html = boostPFSTemplate.vendorHtml;
        }
        return html;
    } // [web:22]


    function buildPrice(data) {
        var html = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
            boostPFSThemeConfig.custom.show_price) {
            html = '<p class="boost-pfs-filter-product-item-price">';
            if (onSale) {
                html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min) + '</span>';
                html += '<s>' + Utils.formatMoney(data.compare_at_price_min) + '</s> ';
            } else {
                if (priceVaries) {
                    html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
                }
                html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min) + '</span>';
            }
            html += '</p>';
        }
        return html;
    } // [web:22]


    function buildLabels(data) {
        var soldOutLabel = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_enable') &&
            boostPFSThemeConfig.custom.sold_out_enable && soldOut) {
            soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
        }
        var saleLabel = '';
        if (boostPFSThemeConfig.custom.sale_label_enable && onSale && !soldOut) {
            var salePercent = 0;
            if (boostPFSThemeConfig.custom.sale_label_display == 'sale_percent') {
                var denom = data.compare_at_price_max || data.compare_at_price_min || 0;
                if (denom > 0) salePercent = Math.round((data.compare_at_price_min - data.price_min) * 100 / denom);
            }
            saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '').replace(/percent/g, '-' + salePercent + '%');
        }
        return soldOutLabel + saleLabel;
    } // [web:22]


    function buildTagLabels(data, showall) {
        if (!boostPFSThemeConfig.custom.tag_label_enable) return '';
        var out = '';
        var tags = Array.isArray(data.tags) ? data.tags : [];
        if (showall) {
            tags.forEach(function(tag) {
                if (tag.indexOf('pfs:label') !== -1) {
                    out += boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
                }
            });
        } else {
            for (var i = tags.length - 1; i >= 0; i--) {
                var t = tags[i];
                if (t.indexOf('pfs:label') !== -1) {
                    out += boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, t.split('pfs:label-')[1]);
                    break;
                }
            }
        }
        return out;
    } // [web:22]


    function buildReview(data) {
        var html = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
            boostPFSThemeConfig.custom.show_product_review === true) {
            html = '<div class="yotpo bottomLine" data-yotpo-product-id="' + escapeHtml(data.id) + '"> </div>';
        }
        return html;
    } // [web:22]


    function buildActiveSwapClass() {
        if (!Utils.isMobile() && images.length > 1 &&
            boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
            boostPFSThemeConfig.custom.active_image_swap === true) {
            return 'has-bc-swap-image';
        }
        return '';
    } // [web:22]


    // Grid item template only
    ProductGridItem.prototype.compileTemplate = function(data) {
        if (!data) data = this.data;
        data = prepareShopifyData(data);
        cacheAllSwatches(data);

        var itemHtml = boostPFSTemplate.productGridItemHtml;
        var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
        var saleClass = onSale ? boostPFSTemplate.saleClass : '';


        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
        itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass());
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
        itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
        itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
        if (typeof Integration === 'undefined' ||
            (typeof Integration != 'undefined' &&
                typeof Integration.hascompileTemplate == 'function' &&
                !Integration.hascompileTemplate('reviews'))) {
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
        }
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
        itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass());
        itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, escapeHtml(data.title || ''));
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, escapeHtml(data.handle || ''));
        itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, escapeHtml(data.vendor || ''));
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
        return itemHtml;
    }; // [web:22]


    function swapImage() {
        if (!Utils.isMobile()) {
            if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
                boostPFSThemeConfig.custom.active_image_swap === true) {
                jQ(".boost-pfs-filter-product-item").each(function() {
                    var $item = jQ(this);
                    var $img = $item.find('.boost-pfs-filter-product-item-main-image');
                    var flipSrc = $img.data('img-flip-src');
                    var flipSet = $img.data('img-flip-srcset');
                    var widths = $img.data('widths');
                    var alt = $img.attr('alt') || '';
                    if (flipSrc) {
                        var html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad" ' +
                            'data-srcset="' + flipSet + '" data-src="' + flipSrc + '" data-widths="[' + widths + ']" data-sizes="auto" ' +
                            'src="' + boostPFSImgDefaultSrc + '" alt="' + escapeHtml(alt) + '"/>';
                        $item.find('.boost-pfs-filter-product-item-image-link').append(html);
                    }
                });
            }
        }
    } // [web:22]


    function bindSwatchInteractions() {
        jQ('.boost-pfs-filter-item-swatch li span').off('.swatch');
        jQ('.boost-pfs-filter-item-swatch li span')
            .on('mouseenter.swatch', function() {
                if (isMobileUA) return;
                var $img = jQ(this).closest('.boost-pfs-filter-product-item-inner')
                    .find('.boost-pfs-filter-product-item-main-image');
                var set = jQ(this).data('img');
                if (set) $img.attr('srcset', set);
            })
            .on('click.swatch', function() {
                var $img = jQ(this).closest('.boost-pfs-filter-product-item-inner')
                    .find('.boost-pfs-filter-product-item-main-image');
                var set = jQ(this).data('img');
                if (set) $img.attr('srcset', set);
            })
            .on('focus.swatch', function() {
                if (!jQ('body').hasClass('boost-pfs-ada')) return;
                var $img = jQ(this).closest('.boost-pfs-filter-product-item-inner')
                    .find('.boost-pfs-filter-product-item-main-image');
                var set = jQ(this).data('img');
                if (set) $img.attr('srcset', set);
            });
    } // [web:3]


    function showAllSwatches() {
        jQ(".boost-pfs-filter-product-item").each(function() {
            var $item = jQ(this);
            var $lis = $item.find(".boost-pfs-filter-item-swatch > li");
            $lis.removeClass("d-none");
            $lis.find("span").removeClass("check");
        });
    } // [web:3]


    // Global swatch store
    window.globalProductSwatches = window.globalProductSwatches || {};

    // Independent collector
    function cacheAllSwatches(data) {
        if (!data || !data.handle) return;
        var handle = data.handle.toLowerCase();
        var buckets = {
            all: [],
            core: [],
            seasonal: []
        };

        function pushTo(bucketArr, color, img) {
            var cname = (color || '').trim();
            if (!cname) return;
            bucketArr.push({
                color: cname,
                image: img || ''
            });
        }

        // Collect from main product variants
        if (Array.isArray(data.variants)) {
            data.variants.forEach(function(v) {
                var cname = v && v.option2 ? v.option2.trim() : '';
                if (!cname) return;
                var img = v.image || (v.featured_image && v.featured_image.src) || '';
                pushTo(buckets.all, cname, img);
            });
        }

        // Collect from hidden selects (core)
        try {
            jQ('#product-core1-' + handle + '-c1 option,' +
                    '#product-core2-' + handle + '-c2 option,' +
                    '#product-core3-' + handle + '-c3 option,' +
                    '#product-core4-' + handle + '-c4 option')
                .each(function() {
                    pushTo(buckets.core, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
        } catch (e) {}

        // Collect from hidden selects (seasonal)
        try {
            jQ('#product-seasonal1-' + handle + '-s1 option,' +
                    '#product-seasonal2-' + handle + '-s2 option,' +
                    '#product-seasonal3-' + handle + '-s3 option,' +
                    '#product-seasonal4-' + handle + '-s4 option')
                .each(function() {
                    pushTo(buckets.seasonal, jQ(this).attr('colorName'), jQ(this).attr('colorImg'));
                });
        } catch (e) {}

        // Flatten & dedupe
        var allColors = [].concat(buckets.all, buckets.core, buckets.seasonal);
        var seen = new Set();
        var deduped = [];
        allColors.forEach(function(entry) {
            var key = (entry.color || '').toLowerCase().trim();
            if (!key || seen.has(key)) return;
            seen.add(key);
            deduped.push(entry);
        });

        window.globalProductSwatches[handle] = deduped;
    }



    function applyGlobalColorPrune(handle, selectedColor) {
        handle = (handle || '').toLowerCase();
        var swatches = window.globalProductSwatches[handle] || [];
        if (!swatches.length) return;

        var chosen = swatches.find(function(entry) {
            return entry.color.toLowerCase() === selectedColor.toLowerCase();
        });
        if (!chosen) return;

        // Hide original swatches
        var $orig = jQ('.boost-pfs-filter-item-swatch[data-handle="' + handle + '"]');
        if ($orig.length) $orig[0].style.setProperty('display', 'none', 'important');

        // Remove any previous pruned swatches
        jQ('.pruned-swatch[data-handle="' + handle + '"]').remove();

        // Add pruned swatch
        var html = '<ul class="boost-pfs-filter-item-swatch pruned-swatch" data-handle="' + handle + '">' +
            '<li>' +
            '<div class="boost-pfs-product-item-tooltip">' + chosen.color + '</div>' +
            '<span tabindex="0" aria-label="' + chosen.color + '" ' +
            'data-colorname="' + chosen.color.toLowerCase().replace(/\s+/g, '-') + '" ' +
            'data-value="' + chosen.color + '" ' +
            'data-img="' + chosen.image + '">' +
            '</span>' +
            '</li>' +
            '</ul>';
        $orig.after(html);

    }

    function lazySwapPrunedImages() {
        const items = document.querySelectorAll('.boost-pfs-filter-product-item');

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;

                    const el = entry.target;
                    const $pruned = jQ(el).find(".pruned-swatch span[data-img]");
                    if ($pruned.length) {
                        const imgSrc = $pruned.data("img");
                        if (imgSrc) {
                            const $img = jQ(el).find(".boost-pfs-filter-product-item-image img");
                            if ($img.length) {
                                $img.attr({
                                    src: imgSrc,
                                    "data-src": imgSrc,
                                    srcset: imgSrc
                                });
                            }
                        }
                    }

                    observer.unobserve(el); // only swap once
                });
            }, {
                rootMargin: '200px 0px'
            });

            items.forEach(item => observer.observe(item));
        } else {
            // fallback for old browsers
            jQ(window).on('scroll.lazySwap resize.lazySwap load.lazySwap', function() {
                items.forEach(item => {
                    const rect = item.getBoundingClientRect();
                    if (rect.top < window.innerHeight + 200) {
                        const $pruned = jQ(item).find(".pruned-swatch span[data-img]");
                        if ($pruned.length) {
                            const imgSrc = $pruned.data("img");
                            const $img = jQ(item).find(".boost-pfs-filter-product-item-image img");
                            if ($img.length && imgSrc) {
                                $img.attr({
                                    src: imgSrc,
                                    "data-src": imgSrc,
                                    srcset: imgSrc
                                });
                            }
                        }
                    }
                });
            }).trigger('scroll.lazySwap');
        }
    }

    window.addEventListener('load', lazySwapPrunedImages);
    window.addEventListener('scroll', lazySwapPrunedImages);


    function resetGlobalColorPrune(handle) {
        handle = (handle || '').toLowerCase();
        jQ('.pruned-swatch[data-handle="' + handle + '"]').remove();
        jQ('.boost-pfs-filter-item-swatch[data-handle="' + handle + '"]').show();
    }

    var syncOnScroll = debounce(function() {
        afterRenderOnce();
    }, 10000); // [web:3]


    function setupVisibilitySync() {
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function(entries) {
                var needSync = false;
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) needSync = true;
                });
                if (needSync) afterRenderOnce();
            }, {
                rootMargin: '200px 0px'
            });

            jQ('.boost-pfs-filter-product-item').each(function() {
                io.observe(this);
            });

        } else {
            jQ(window).off('scroll.swatchSync').on('scroll.swatchSync', syncOnScroll);
        }

        document.addEventListener('lazyloaded', syncOnScroll, true);
        document.addEventListener('lazybeforeunveil', syncOnScroll, true);
    } // [web:22]



    // Unified post-render routine: renders toolbar too
    var afterRenderOnce = debounce(function() {
        // Normalize data-colorname
        jQ(".boost-pfs-filter-product-item").each(function() {
            var $t = jQ(this).find(".boost-pfs-filter-item-swatch").children("li");
            $t.each(function() {
                var $s = jQ(this).find("span");
                var e = $s.attr("aria-label") || '';
                var getColorVal = e.replace(/ /g, "-").replace(/\//g, "-").toLowerCase();
                $s.attr("data-colorname", getColorVal);
            });
        });

        swapImage();
        bindSwatchInteractions();

        var selectedTitle = getSelectedColorFromChips();

        // Apply prune or reset based on filter state
        jQ(".boost-pfs-filter-product-item").each(function() {
            var handle = jQ(this).find(".boost-pfs-filter-product-item-title").attr("titlename");
            if (!handle) return;

            if (selectedTitle) {
                applyGlobalColorPrune(handle, selectedTitle);
            } else {
                resetGlobalColorPrune(handle); // show all swatches again
            }
        });

        //setupVisibilitySync();
        // Render sorting
        try {
            if (jQ(Selector.topSorting).length) {
                var sorting = new ProductSorting({
                    $element: jQ(Selector.topSorting)
                });
                sorting.render();
                sorting.bindEvents();
            }
        } catch (e) {}


        // Render grid-only display type
        try {
            var $display = jQ('.boost-pfs-filter-top-display-type');
            if ($display.length) {
                var displayType = new ProductDisplayType({
                    $element: $display
                });
                displayType.render();
            }
        } catch (e) {}


        // Render per-page limit if used
        try {
            var $limit = jQ('.boost-pfs-filter-show-limit');
            if ($limit.length) {
                var limit = new ProductLimit({
                    $element: $limit
                });
                limit.render();
            }
        } catch (e) {}


        // Breadcrumb if container and data available
        try {
            var $bc = jQ('.boost-pfs-filter-breadcrumb');
            if ($bc.length) {
                var bread = new Breadcrumb({
                    $element: $bc,
                    collectionData: window.bcSfFilterCollection || null
                });
                bread.render();
            }
        } catch (e) {}


        // Pagination: core will render using our override; optional manual render if needed:
        // try {
        //   var $pag = jQ('.boost-pfs-filter-bottom-pagination');
        //   if ($pag.length && typeof FilterApi !== 'undefined' && FilterApi.result && typeof FilterApi.result.total_product === 'number') {
        //     var pagination = new ProductPaginationDefault({ $element: $pag, totalProduct: FilterApi.result.total_product });
        //     pagination.render();
        //   }
        // } catch(e) {}
    }, 50); // [web:22]


    // After-render hook
    ProductList.prototype.afterRender = function(data) {
        if (!data) data = this.data;


        if (window.SPR &&
            typeof window.SPR.initDomEls == 'function' &&
            typeof window.SPR.loadBadges == 'function' &&
            boostPFSThemeConfig.custom.show_product_review) {
            window.SPR.initDomEls();
            window.SPR.loadBadges();
        } // [web:22]


        // Remove promo placeholders by title
        jQ(".boost-pfs-filter-product-item").each(function() {
            var titleCheck = jQ(this).find(".boost-pfs-filter-product-bottom-inner").children(".boost-pfs-filter-product-item-title").text();
            if (titleCheck === "vetPromo1" || titleCheck === "vetPromo2" || titleCheck === "vetPromo3" ||
                titleCheck === "dentalPromo1" || titleCheck === "dentalPromo2" || titleCheck === "dentalPromo3" ||
                titleCheck === "Menshealth1" || titleCheck === "Menshealth2" || titleCheck === "Menshealth3") {
                jQ(this).remove();
            }
        }); // [web:3]


        // Equalize grid heights (grid-only)
        setTimeout(function() {
            equalHeight(data);
        }, 700);
        jQ(window).off('resize.equalHeight').on('resize.equalHeight', debounce(function() {
            equalHeight(data);
        }, 200));


        if (typeof boostRemoveImageLoadingAnimation == 'function') {
            boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
        }


        if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') &&
            boostPFSThemeConfig.custom.layout_type == 'fullwidth' &&
            !Utils.isMobile()) {
            jQ('body').addClass('boost-pfs-filter-fullwidth-page');
        }


        afterRenderOnce();
    }; // [web:22]


    document.addEventListener("DOMContentLoaded", afterRenderOnce);
    document.addEventListener("boost-pfs-filter-rendered", afterRenderOnce); // [web:22]


    function equalHeight(data) {
        var rows = [];
        var currentTop = -1;
        jQ('.boost-pfs-filter-product-item').each(function() {
            var $el = jQ(this);
            var top = $el.offset().top;
            if (top !== currentTop) {
                rows.push([$el]);
                currentTop = top;
            } else {
                rows[rows.length - 1].push($el);
            }
        });
        rows.forEach(function(group) {
            var max = 0;
            group.forEach(function($el) {
                max = Math.max(max, $el.find('.boost-pfs-filter-product-bottom-inner').height());
            });
            group.forEach(function($el) {
                $el.find('.boost-pfs-filter-product-bottom-inner').css({
                    minHeight: max
                });
            });
        });


        var cfg = getBoostFilterConfig();
        var aspect_ratio = cfg.general && cfg.general.aspect_ratio ? cfg.general.aspect_ratio : 'false';
        if (aspect_ratio != 'false') {
            var cropImagePosition = (cfg.general && cfg.general.cropImagePossitionEqualHeight) || 'center';
            var widthImage = jQ('.boost-pfs-filter-product-item').width();
            var heightImage = 0;


            var ratioCfg = boostPFSThemeConfig && boostPFSThemeConfig.custom && boostPFSThemeConfig.custom.aspect_ratio;
            var ratioOther = boostPFSThemeConfig && boostPFSThemeConfig.custom && boostPFSThemeConfig.custom.aspect_ratio_other;


            if (aspect_ratio != 'other' && ratioCfg) {
                var r = ratioCfg.split(':');
                var ratio = parseInt(r[1], 10) / parseInt(r, 10);
                heightImage = widthImage * ratio;
            } else if (aspect_ratio == 'other' && ratioOther) {
                var ro = ratioOther.split(':');
                var ratioo = parseInt(ro[1], 10) / parseInt(ro, 10);
                heightImage = widthImage * ratioo;
            } else {
                return;
            }
            jQ('.boost-pfs-filter-product-item-image-link')
                .css({
                    paddingTop: heightImage + 'px'
                })
                .addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);
        }
    } // [web:22]


    function boostRemoveImageLoadingAnimation($selector) {
        if ($selector.length) $selector.removeAttr('data-boost-image-loading-animation');
    } // [web:22]


    window.eventColorSwatchesChange = function(node) {
        var $span = jQ(node).find('span');
        var set = $span.data('img');
        var $img = jQ(node).closest('.boost-pfs-filter-product-item-inner')
            .find('.boost-pfs-filter-product-item-main-image');
        if (set) $img.attr('srcset', set);
    };
})();